import React from 'react';
import cn from 'clsx';

import Typography from '../../../typography/typography';

import styles from './page-title.scss';

interface PageTitleProps {
  className?: string;
  showDivider?: boolean;
  subtitle?: string | React.ReactNode;
  title?: (() => string) | string | React.ReactNode;
}

function PageTitle(props: React.PropsWithChildren<PageTitleProps>) {
  const {
    children,
    className = '',
    showDivider = false,
    subtitle = '',
    title = ''
  } = props;

  return (
    <div
      className={cn(
        showDivider ? styles['container-divider'] : styles['container'],
        `${className || ''} page-title`
      )}
    >
      <div className="page-title__content">
        {title && (
          <Typography
            className={cn(styles['title'], 'page-title__content-title')}
            tag="h1"
            variant="h4"
            weight="black"
          >
            {typeof title === 'function' ? title() : title}
          </Typography>
        )}

        {subtitle && (
          <Typography
            className={cn(styles['subtitle'], 'page-title__content-subtitle')}
            size="small"
            tag="div"
          >
            {subtitle}
          </Typography>
        )}
      </div>
      {children}
    </div>
  );
}

export default PageTitle;
